export default {
  common: {
    clearAll: 'Borrar Todo',
    restart: 'Reiniciar'
  },
  error: {
    restart: 'Parece que estás intentando usar algo que todavía estamos desarrollando...',
    tryAgainMsg:
      'Por favor, inténtalo de nuevo, si este error continúa, contacta con el equipo de soporte de Metrica Sports'
  },
  verifyEmail: {
    generateLink: 'Generar un nuevo enlace entrando en Play',
    readyToLogin: 'Estás listo para iniciar sesión en Play',
    successfully: 'Correo electrónico verificado con éxito',
    unsuccessfully: 'Error al verificar el correo electrónico, token no válido'
  },
  download: {
    bodyTitle: 'Descargar',
    bodyTitleFromTrial: 'Registro Exitoso',
    bodyTitleFromAcceptInvitation: 'Estamos cambiando tu cuenta',
    bodyTitleFromDeclineInvitation: 'Invitación Rechazada',
    bodyText: 'Haz clic en el siguiente enlace para descargar %{products}',
    bothProducts: 'PlayBase y/o Nexus',
    bodyTextFromTrial:
      '¡Bienvenido a tu periodo prueba! Comprueba tu correo electrónico para obtener un enlace de verificación (mira la carpeta de correo no deseado).',
    bodyTextFromAcceptInvitation:
      'El proceso llevará algún tiempo. Mientras tanto, puedes seguir usando Metrica Sports como de costumbre.',
    bodyTextFromDeclineInvitation:
      '¡Has rechazado la invitación! Haz clic en el siguiente enlace para descargar %{products}',
    thanks:
      '¡Gracias por registrarte en Metrica Sports! Para comenzar con tu prueba, descarga %{products}.',
    play2: {
      description:
        'Metrica PlayBase es una herramienta de análisis intuitiva diseñada para entrenadores aficionados y prosumidores, pequeños clubes y analistas independientes. Simplifica el proceso de evaluación del rendimiento, haciéndolo accesible para todos.'
    },
    play3: {
      description:
        'Metrica Nexus está diseñado para analistas y entrenadores de élite que buscan información exhaustiva sobre el rendimiento. Con herramientas avanzadas a tu alcance, puedes mejorar las estrategias del equipo y lograr el éxito.'
    }
  }
}
